import { Breakpoints, styled, ThemeDefinition } from '@volkswagen-onehub/components-core';

export const PageMainContainer: any = styled.main`
  ${({ theme }: { theme: ThemeDefinition }) => {
    return `
      display: flex;
      flex-direction: column;

      @media (min-width: ${Breakpoints.b1280}px) {
        border-radius: 8px;
        border: 1px solid ${theme.colors.border.default};
        margin-right: 8px; 
        overflow: hidden;
        padding: ${theme.size.static450} ${theme.size.static510};
      }
    `;
  }}
`;

export const PageContentTitle = styled.div`
  ${({ theme }: { theme: ThemeDefinition }) => {
    return `
      display: flex;
      /* VW Head Light; TextCustom emits an invalid "font-weight: light", so the weight is inherited */
      font-weight: 300;
      padding-top: ${theme.size.static400};

      @media (min-width: ${Breakpoints.b1280}px) {
        padding-top: 0;
      }
    `;
  }}
`;

export const StyledContentDescription = styled.div`
  ${({ theme }: { theme: ThemeDefinition }) => {
    return `
      display: flex;
      padding: ${theme.size.static150} 0;

      @media (min-width: ${Breakpoints.b960}px) {
        padding: ${theme.size.static300} 0;
      }

      @media (min-width: ${Breakpoints.b1280}px) {
        padding: ${theme.size.static250} 0 ${theme.size.static400} 0;
      }
    `;
  }}
`;
